import type { MessageData, PaginatedResponse, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import { crossAccessEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreateCrossAccessRequest,
	ListCrossAccessParams,
	OrganizationCrossAccess,
	UpdateCrossAccessRequest,
} from "../types";

export const crossAccessService = {
	async list(params: ListCrossAccessParams): Promise<PaginatedResponse<OrganizationCrossAccess>> {
		const response = await apiClient.get<PaginatedResponse<OrganizationCrossAccess>>(
			crossAccessEndpoints.list,
			{ params }
		);
		return response.data;
	},

	async getById(id: string): Promise<OrganizationCrossAccess> {
		const url = replaceParams(crossAccessEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<OrganizationCrossAccess>>(url);
		return response.data.data;
	},

	async create(data: CreateCrossAccessRequest): Promise<OrganizationCrossAccess> {
		const response = await apiClient.post<SuccessResponse<OrganizationCrossAccess>>(
			crossAccessEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateCrossAccessRequest): Promise<OrganizationCrossAccess> {
		const url = replaceParams(crossAccessEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<OrganizationCrossAccess>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(crossAccessEndpoints.delete, { id });
		await apiClient.delete<SuccessResponse<MessageData>>(url);
	},
};
